import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, Alert as MuiAlert } from '@mui/material';
import { clearAlert } from '../../store/alert';

export default function Alert() {
    const dispatch = useDispatch();
    const alertState = useSelector(state => state.alert);
    const alert = alertState?.alert || alertState;
    const message = alert?.message;
    const type = alert?.type;
    const duration = alert?.duration;

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(clearAlert());
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={!!message}
            autoHideDuration={duration || 4000}
            onClose={handleClose}
            sx={{ zIndex: 9999, mt: 8 }}
        >
            <MuiAlert 
                onClose={handleClose} 
                severity={type || 'success'} 
                variant="filled"
                sx={{ 
                    width: '100%', 
                    borderRadius: 3,
                    fontWeight: 500,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.1)'
                }}
            >
                {message}
            </MuiAlert>
        </Snackbar>
    );
}
